import _ from 'lodash';

let initInvoices = {
	expires: 0,
	submitting: false,
	from: null,
	to: null,
	data: {},
	singles: {}
}

const invoices = (state = initInvoices, action) => {
	switch (action.type) {
		case 'USER_FAILURE':
		case 'MEMBER_FAILURE':
		case 'LOGOUT_SUCCESS':
		case 'LOGIN_SUCCESS':
			return initInvoices;
		case 'INVOICES_REQUEST':
			return {...state, submitting: true}
		case 'INVOICES_SUCCESS':
			const expires = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr
			const f = (state.from === null || action.extra.from < state.from) ? action.extra.from : state.from;
			const t = (state.to === null || action.extra.to > state.to) ? action.extra.to : state.to;
			
			const i = _.merge({...state.data}, _.keyBy(action.response, 'invoice_no'));

			return {...state, expires: expires, data: i, submitting: false, from: f, to: t  }		
		case 'INVOICES_FAILURE':
			return {...state, submitting: false}
		case 'PP_CAPTURE_REQUEST':
		case 'INVOICE_REQUEST':
			const sr = {...state.singles, [action.extra.invoice_no]: { submitting: true, error: null }}
			return {...state, singles: sr}
		case 'INVOICE_SUCCESS':
		case 'CHECKOUT_SUCCESS':
		case 'PP_CAPTURE_SUCCESS':
			const ss = {...state.singles, [action.response.invoice_no]: {submitting: false, error: null }}
			const sd = {...state.data, [action.response.invoice_no]: action.response }
			return {...state, data:sd, singles: ss}
		case 'INVOICE_FAILURE':
		case 'PP_CAPTURE_FAILURE':
			const sf = {...state.singles, [action.extra.invoice_no]: { submitting: false, error: action.error }}
			return {...state, singles: sf}
		default:
			return state;
	}
}

export default invoices